import { AsYouType } from "libphonenumber-js";

export default function baseFormValidators() {
  const isEmpty = (fieldName, fieldValue) => {
    return !fieldValue ? `The ${fieldName} field is required` : "";
  };

  const minLength = (fieldValue, min) => {
    // Todo: debounce the validation to give time for typing
    return fieldValue.length < min
      ? `The field must be at least ${min} characters long`
      : "";
  };

  const isEmail = (fieldName, fieldValue) => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !regex.test(fieldValue)
      ? `The input is not a valid ${fieldName} address`
      : "";
  };

  const isValidMobile = (mobile, internationalCode) => {
    const asYouType = new AsYouType(`${internationalCode}`);
    asYouType.input(`${mobile}`);
    return !asYouType.isValid()
      ? `Invalid mobile number for the country code ${asYouType.getCountry()}`
      : "";
  };

  return { isEmpty, minLength, isEmail, isValidMobile };
}
